// Libs
import React, { memo, useEffect } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { UniqueIdentifier } from '@dnd-kit/core';
import { Stack } from '@mui/material';
// Components, Layouts, Pages
// Others
import { ColumnTypeKanban, IBaseKanban } from '~/utils/interface/common';
// Styles, images, icons

type ContainerProps<T extends IBaseKanban> = {
  id: UniqueIdentifier;
  children: React.ReactNode;
  description?: string;
  onAddItem?: () => void;
  render: (data: ColumnTypeKanban<T>) => React.ReactNode;
  data: ColumnTypeKanban<T>;
};

function ColumnKanban<T extends IBaseKanban>(props: ContainerProps<T>) {
  //#region Destructuring Props
  const { id, children, data, render } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { attributes, setNodeRef } = useSortable({
    id: id,
    data: {
      type: 'column',
    },
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Stack id='columnKanbanComponent' direction={'column'} {...attributes} ref={setNodeRef}>
      {render(data)}
      {children}
    </Stack>
  );
}

export default memo(ColumnKanban) as typeof ColumnKanban;
